export default function getAssetCdnUrl(fileName: string): string {
  return `https://cdn.formfunction.xyz/${fileName}`;
}
